import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  card: {
    width: rw(54),
    height: rh(36),
    borderRadius: rw(8),
    overflow: 'hidden',
    isolation: 'isolate',
    borderWidth: rw(1),
    borderColor: theme.COLOR_OPACITY_BLACK_200,
  },
  platinum: { borderColor: theme.COLOR_OPACITY_WHITE_100 },
  middle: { width: rw(264), height: rh(165), borderRadius: rw(20) },
  large: { width: rw(300), height: rh(189), borderRadius: rw(20) },
  cover: { position: 'absolute', inset: 0, width: '100%', height: '100%' },
  frozen: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    transform: [{ rotate: '180deg' }],
    mixBlendMode: 'screen',
  },
  cloud: { position: 'absolute', right: rw(4), top: rh(3), width: rw(12), height: rw(12) },
  cloudMiddle: { right: rw(19), top: rh(15), width: rw(32), height: rw(32) },
  cloudLarge: { right: rw(20), top: rh(16), width: rw(32), height: rw(32) },
  number: {
    position: 'absolute',
    left: rw(5),
    bottom: rh(3),
    fontSize: rf(13),
    lineHeight: rf(18.2),
    color: theme.COLOR_NEUTRAL_950,
  },
  numberPlatinum: { color: theme.COLOR_NEUTRAL_50 },
}))
